document.addEventListener('DOMContentLoaded', function() {
    const galleryContainer = document.querySelector('#boa-media-gallery');
    galleryContainer?.addEventListener('click', (e) => {
        const clickedMedia = e.target.closest('.boa-media-gallery-img')
        if (!clickedMedia){
            return;
        }
        const clickedMediaIndex = clickedMedia?.getAttribute('data-media-index');
        openGalleryCarousel(clickedMediaIndex)
    });
    const closeButton = document?.querySelector('.boa-media-carousel-close-button-container');
    closeButton?.addEventListener('click', closeGalleryCarousel);

    handleCarouselHashChange();
});

function closeGalleryCarousel(){
    sessionStorage.setItem("navigatedFromMediaGalleryOrCarousel", true);
    window.history.back(-1);
};

function openGalleryCarousel(index) {
    document.body.classList.add('boa-prevent-scrolling');
    
    const modal = document.getElementById('boa-media-carousel-container');
    if (!modal){
        return;
    }
    modal.style.display = 'flex';
    const currentHash = `#galleryModal-swiper-item-${index}`;
    window.history.pushState(null, null, window.location.pathname + window.location.search + currentHash);

    const current = currentIndexFromHash();

    const swiper =  new Swiper('.swiper', {
        zoom:true,
        slidesPerView: 1,
        initialSlide: current,
        on: {
            init: function () {
                initializeCount();
            },
            slideChange: function (params) {
                updateCount(params);
            },
            transitionStart: function(){
                const video = modal.querySelector('video')                
                video?.pause();
            },
            transitionEnd: function(){
                const activeIndex = this.activeIndex;
                const activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
                const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
                activeSlideVideo?.play();
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
  });

  function updateCount(params) {
    const current = params.activeIndex + 1;
    const total = params.slides.length;
    const currentElement = document.querySelector('.swiper-current');
    const totalElement = document.querySelector('.swiper-total');

    if (currentElement && totalElement) {
        currentElement.textContent = current;
        totalElement.textContent = total;
    }
}
    if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)){
        const ctaContainer = document.querySelector('#cta-container');
        ctaContainer.classList.remove('boa-media-gallery-mobile-cta');
    }

};

function initializeCount(){
    const currentIndex = currentIndexFromHash(); 

    if (!currentIndex && currentIndex !== 0){
        return;
    }
    const currentElement = document.querySelector('.swiper-current');
    const totalElement = document.querySelector('.swiper-total');
    const mediaItems = document.querySelectorAll('.media-viewer__item');

    if (currentElement && totalElement) {
        currentElement.textContent = currentIndex + 1;
        totalElement.textContent = mediaItems?.length || 0;
    }
}
function handleCarouselHashChange() {
    const hash = location.hash;
    const currentIndex = currentIndexFromHash()
    if (hash.includes('#galleryModal-swiper-item')) {
        openGalleryCarousel(currentIndex);
    }
};
function currentIndexFromHash(){
    const hash = location.hash;
    const parts = hash?.split('-');
    const lastPart = parts[parts.length - 1];
    return isNaN(parseInt(lastPart, 10)) ? null : parseInt(lastPart, 10); 
};

